import React, { useMemo, useState } from 'react';
import { __, sprintf } from '@wordpress/i18n';

// tools
import formatDeadlineDate from '../../../../helpers/formatDeadlineDate';
import getProjectCardLabel from '../../../../helpers/getProjectCardLabel';

// store
import { storeSet } from '../../../../store';

// components
import ProjectStatusIcon from '../../../../components/ProjectStatusIcon';
import ButtonIconContextMenu from '../../../../components/ButtonWrapper/components/ButtonIconContextMenu';
import ModalEditProjectField from '../../../../components/ModalEditProjectField';
import TripleDotsIcon from '../../../../icons/TripleDotsIcon';
import MovieIcon from '../../../../icons/MovieIcon';

// Number of new comunicazioni messages since the project was last opened,
// reset by POST /projects/{id}/seen.
const getNewCommentsCount = (project) => {
    const parsed = parseInt(project.unreadMessagesCount, 10);

    return Number.isNaN(parsed) || parsed <= 0 ? 0 : parsed;
};

const ProjectCard = ({ project, onOpen }) => {
    const [editField, setEditField] = useState(null);
    const label = useMemo(() => getProjectCardLabel(project), [project]);
    const newComments = getNewCommentsCount(project);

    const menuItems = [
        { label: __('Rinomina', 'soundbetween'), onClick: () => setEditField('title') },
        { label: __('Modifica scadenza', 'soundbetween'), onClick: () => setEditField('deadline') },
        { label: __('Archivia', 'soundbetween'), onClick: () => storeSet('archiveProject', project.id) }
    ];

    return (
        <li className="projectCard">
            <div
                className="projectCard__tile"
                tabIndex={0}
                role="button"
                aria-label={project.title}
                onClick={() => onOpen(project.id)}
                onKeyDown={(e) => {
                    if ('Enter' === e.key || ' ' === e.key) {
                        e.preventDefault();
                        onOpen(project.id);
                    }
                }}
            >
                <picture className="projectCard__thumbnail">
                    {project.thumbnailUrl
                        ? <img src={project.thumbnailUrl} alt={project.title} loading="lazy"/>
                        : <span className="projectCard__thumbnailPlaceholder" aria-hidden="true">
                            <MovieIcon/>
                        </span>}
                </picture>
                {label
                    ? <span className={`projectCard__label projectCard__label--${label.type}`}>
                        {label.text}
                    </span>
                    : null}
                {newComments
                    ? <span
                        className="projectCard__badge"
                        aria-label={sprintf(__('%d nuovi commenti', 'soundbetween'), newComments)}>
                        {newComments > 99 ? '99+' : newComments}
                    </span>
                    : null}
            </div>

            <div className="projectCard__titleRow">
                <ProjectStatusIcon status={project.status}/>
                <span className="projectCard__title">{project.title}</span>
            </div>

            <div className="projectCard__metaRow">
                <span className="projectCard__deadline">
                    {sprintf(__('Scadenza: %s'), formatDeadlineDate(project.deadline))}
                </span>
                <div className="projectCard__actions">
                    <ButtonIconContextMenu
                        menuItems={menuItems}
                        ariaLabel={sprintf(__('Azioni per %s', 'soundbetween'), project.title)}>
                        <TripleDotsIcon/>
                    </ButtonIconContextMenu>
                </div>
            </div>

            {editField
                ? <ModalEditProjectField
                    project={project}
                    field={editField}
                    visible={true}
                    onHide={() => setEditField(null)}
                />
                : null}
        </li>
    )
}

export default ProjectCard;
